import FormRepeater from "../../../../../../../common/FormReapeater.jsx";
import {Card, Col, Row} from "react-bootstrap";
import ButtonWithIcon from "../../../../../../../common/ButtonWithIcon.jsx";
import {Icons} from "../../../../../../../common/Icons.jsx";
import PropTypes from "prop-types";
import TextareaWiz from "../../../../../../../common/inputs/wizard/TextareaWiz.jsx";
import DateTimeWiz from "../../../../../../../common/inputs/wizard/DateTimeWiz.jsx";
import InputNumericWiz from "../../../../../../../common/inputs/wizard/InputNumericWiz.jsx";
import {useCallback} from "react";
import moment from "moment";
import RadioWiz from "../../../../../../../common/inputs/wizard/RadioWiz.jsx";
import {optionsTakNie} from "../../../../../../../utils/options.js";
import React from 'react';

export const ZadaniaRepeater = (props) => {
    const parent = props.parentListName || 'zadania_list';
    const {wiz, onTotalChange, sumField, section, startDateField, endDateField} = props;

    const calcTotalBudget = (list) => {
        return (list || []).reduce((sum, item) => {
            const budget = parseFloat(item?.budzet_planowany) || 0;
            return sum + budget;
        }, 0)
    }

    const calcStageDates = (list) => {
        let minDate = null;
        let maxDate = null;

        (list || []).forEach((item) => {
            const isMilestone = item?.czy_kamien_milowy === 'Tak';
            const start = item?.data_rozpoczecia || (isMilestone ? item?.data_zakonczenia : null);
            const end = item?.data_zakonczenia;
            const momentStart = start ? moment(start) : null;
            const momentEnd = end ? moment(end) : null;

            if(momentStart && momentStart.isValid()){
                if(!minDate || momentStart.isBefore(minDate)){
                    minDate = momentStart;
                }
            }

            if(momentEnd && momentEnd.isValid()){
                if(!maxDate || momentEnd.isAfter(maxDate)){
                    maxDate = momentEnd;
                }
            }
        })

        return {
            min: minDate ? minDate.format('YYYY-MM-DD') : null,
            max: maxDate ? maxDate.format('YYYY-MM-DD') : null,
        }
    }

    const handleListChange = useCallback((list) => {
        const total = calcTotalBudget(list);
        const totalBudget = total.toFixed(2);
        const {min, max} = calcStageDates(list);

        let updateFields = {
            [parent]: list,
        };

        if (sumField) {
            updateFields[sumField] = totalBudget;
        }
        if (startDateField) {
            updateFields[startDateField] = min;
        }
        if (endDateField) {
            updateFields[endDateField] = max;
        }

        if (typeof wiz?.setWizForm === 'function') {
            // zapis listy + pola sumy -> brak race condition
            const newForm = {
                ...(wiz.form || {}),
                ...updateFields,
            };
            wiz.setWizForm(newForm);
        }

        if (typeof onTotalChange === 'function') {
            onTotalChange(totalBudget);
        }
    }, [parent, wiz, onTotalChange, sumField, startDateField, endDateField]);

    return (
        <FormRepeater
            value={wiz.form?.[parent] || []}
            onChange={handleListChange}
            addButtonText="Dodaj pozycje"
            hideNativeDelete
            form={(row, setRow, idx, remove, clone, setRowMultiple) => {
                const isMilestone = row?.czy_kamien_milowy === 'Tak';
                const isDefined = row?.czy_kamien_milowy === 'Tak' || row?.czy_kamien_milowy === 'Nie';

                return (
                <Card className={'d-flex flex-column gap-2 mb-3 w-100'} key={idx}>
                    <Card.Header className={'d-flex justify-content-between align-items-center'}>
                        <div className={'fw-bold'}>{`Pozycja ${idx+1}`}</div>
                        <ButtonWithIcon
                            text={`Usuń pozycje ${idx+1}`}
                            onClick={() => remove(idx)}
                            icon={<Icons.delete/>}
                            variant={'danger'}
                            className={'mt-4 align-self-start ms-auto'}
                        />
                    </Card.Header>
                    <Card.Body className={'p-3'}>
                        <Row className={isDefined ? "mb-3" : ""}>
                            <Col>
                                <RadioWiz
                                    wiz={wiz}
                                    id={`${parent}.${idx}.czy_kamien_milowy`}
                                    keyName={`${parent}.${idx}.czy_kamien_milowy`}
                                    label={'Czy jest to kamień milowy?'}
                                    options={optionsTakNie}
                                    row={row}
                                    setRow={setRow}
                                    idx={idx}
                                />
                            </Col>
                        </Row>

                        {isDefined && !isMilestone && (
                            <React.Fragment>
                                <Row>
                                    <Col xs={12} sm={12}>
                                        <TextareaWiz
                                            wiz={wiz}
                                            id={`${parent}.${idx}.nazwa`}
                                            keyName={`${parent}.${idx}.nazwa`}
                                            row={row}
                                            setRow={setRow}
                                            idx={idx}
                                            label={`${section}.2.${idx+1}.1. Nazwa zadania`}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} sm={4}>
                                        <DateTimeWiz
                                            wiz={wiz}
                                            keyName={`${parent}.${idx}.data_rozpoczecia`}
                                            row={row}
                                            setRow={setRow}
                                            idx={idx}
                                            hideTime
                                            hideLabel
                                            label={`${section}.2.${idx+1}.2. Data rozpoczęcia`}
                                        />
                                    </Col>
                                    <Col xs={12} sm={4}>
                                        <DateTimeWiz
                                            wiz={wiz}
                                            keyName={`${parent}.${idx}.data_zakonczenia`}
                                            row={row}
                                            setRow={setRow}
                                            idx={idx}
                                            hideTime
                                            hideLabel
                                            label={`${section}.2.${idx+1}.3. Data zakończenia`}
                                        />
                                    </Col>
                                    <Col xs={12} sm={4}>
                                        <InputNumericWiz
                                            wiz={wiz}
                                            keyName={`${parent}.${idx}.budzet_planowany`}
                                            row={row}
                                            setRow={setRow}
                                            idx={idx}
                                            decimal={2}
                                            max={99999999999999.99}
                                            className="text-end"
                                            label={`${section}.2.${idx+1}.4. Budżet planowany`}
                                        />
                                    </Col>
                                </Row>
                            </React.Fragment>
                        )}

                        {isDefined && isMilestone && (
                            <React.Fragment>
                                <Row>
                                    <Col xs={12} sm={12}>
                                        <TextareaWiz
                                            wiz={wiz}
                                            id={`${parent}.${idx}.nazwa`}
                                            keyName={`${parent}.${idx}.nazwa`}
                                            row={row}
                                            setRow={setRow}
                                            idx={idx}
                                            label={`${section}.2.${idx+1}.1. Nazwa kamienia milowego`}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} sm={12}>
                                        <DateTimeWiz
                                            wiz={wiz}
                                            keyName={`${parent}.${idx}.data_zakonczenia`}
                                            row={row}
                                            setRow={(field, value) => {
                                                setRowMultiple({
                                                    data_rozpoczecia: value,
                                                    data_zakonczenia: value
                                                });
                                            }}
                                            idx={idx}
                                            hideTime
                                            hideLabel
                                            label={`${section}.2.${idx+1}.2. Data osiągnięcia kamienia milowego`}
                                        />
                                    </Col>
                                </Row>
                            </React.Fragment>
                        )}
                    </Card.Body>
                </Card>
                )
            }}
        />
    );
}

ZadaniaRepeater.propTypes = {
    wiz: PropTypes.object.isRequired,
    parentListName: PropTypes.string.isRequired,
    onTotalChange: PropTypes.func,
    sumField: PropTypes.string,
    startDateField: PropTypes.string,
    endDateField: PropTypes.string,
}

export default ZadaniaRepeater
